import { useEffect, useState } from 'react'
import {useAuth} from '../core/Auth'
import { loginByToken, getLoggedUser as getLoggedUserAPI } from '../../../../services/auth'
import { Navigate, useParams } from 'react-router-dom'
import QueryString from 'qs'
import { useQueries } from 'react-query'
import { Nav } from 'react-bootstrap'

export const LoginByToken = () => {
  const {saveAuth, setCurrentUser} = useAuth()
  const params = useParams()
  const searchParams = new URLSearchParams(document.location.search)
  const [redirect, setRedirect] = useState("") 
  useEffect(() => {

    const  login =  async () => {
      let token = searchParams.get("token");
      if(!token){
        setRedirect("/auth/login")
      }
     try{
      const data:any = await loginByToken(token+"");
     
     
      if(!data || data.success === 0){
        setRedirect("/auth/login")
      }
      saveAuth(data.data);
      const tenantName = data.data.tenant_name || "";
      localStorage.setItem('selectedTenant', tenantName);
      const user:any = await getLoggedUserAPI();
        setCurrentUser(user)
        console.log("user", user)
      

     }catch(e){
        console.error(e)
        setRedirect("/auth/login")
     }
      

    }
    login()
  }, [])
  
  return (<>
  {redirect && <Navigate to={redirect} />}
  <br /><br /><br/>
  <br /><br /><br/>
  Accesso in corso, attendi....
  <br /><br /><br/>
  <br /><br /><br/>
  </>)
}